module.exports = require('./helpers/bundle-url').getBundleURL('7oW7R') + "logo.c51670a8.svg";